import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { toArray, toFormValues } from '../../policy_management/utils'
import FormattedPolicyFrame from '../FormattedPolicyFrame'

const propTypes = {
  /**
   * Policy payload (raw policy) object
   */
  rawPolicy: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Form options map
   */
  policyFormOptionsMap: PropTypes.object, // eslint-disable-line react/forbid-prop-types
}

const defaultProps = {
  rawPolicy: {},
  policyFormOptionsMap: {},
}

function ReadOnlyInput(props) {
  const { values, optionsMap } = props

  return toArray(values)?.map((val) => (
    <div key={val} className="text-break-all mb-1">
      {optionsMap?.[val] || val}
    </div>
  ))
}

function PrettyView(props) {
  const { policyFormOptionsMap, rawPolicy } = props

  const values = useMemo(() => toFormValues(rawPolicy), [rawPolicy])

  return (
    <FormattedPolicyFrame
      renderInput={(input) => <ReadOnlyInput values={values?.[input]} optionsMap={policyFormOptionsMap?.[input]} />}
      displayInput={(input) => !isEmpty(values?.[input])}
    />
  )
}

PrettyView.propTypes = propTypes
PrettyView.defaultProps = defaultProps

export default PrettyView
